export default __webpack_public_path__ + "static/media/girl-default-512x512.a8b63e46.png";